export default {
  strict: true,
  namespaced: true,
  state: {
    list: [],
    loading: false,
    search: '',
    currentPage: 1,
    perPage: 20,
    order: 'id',
    orderAsc: '',
    maxList: 0,
  },
  mutations: {
    setListData (state, data) {
      for (let field in data) {
        state[field] = data[field]
      }
    },
    updateListData (state, data) {
      for (let field in data.fields) {
        let index = state.list.findIndex(x => x.id === data.id)
        state.list[index][field] = data.fields[field]
      }
    }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/discount-codes/list.js